'use client';

import React from 'react';
import { useBranchCode } from '@/components/SiteHostProvider';
import { usePathname } from 'next/navigation';
import { regionalizePath } from '@/lib/config/branches-config';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from '@/components/ui/carousel';

export interface SalesSliderItem {
  slug: string;
  title: string;
  description: string;
  link: string;
}

interface SalesSliderProps {
  items: SalesSliderItem[];
}

export default function SalesSlider({ items }: SalesSliderProps) {
  const pathname = usePathname() || '/';
  // Филиал страницы: по хосту (BRANCH_ROUTING=host) или по /geo/<code>/.
  const pageBranchCode = useBranchCode();
  const currentBranchCode = pageBranchCode;

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="w-full bg-red-600 py-1 mb-3">
      <div className="site-container">
        <Carousel
          opts={{
            align: 'start',
            loop: true,
            dragFree: false,
          }}
          className="w-full"
        >
          <CarouselContent className="-ml-0">
            {items.map((item, index) => {
              const content = (
                <div className="flex items-center justify-center min-h-[32px] px-4">
                  <p className="text-white text-xs md:text-sm font-medium text-center">
                    {item.description || item.title}
                  </p>
                </div>
              );

              // Обрабатываем ссылку с учетом региона
              const getRegionalizedLink = (link: string) => {
                // Если ссылка внешняя или якорная, возвращаем как есть
                if (!link || link.startsWith('http://') || link.startsWith('https://') || link.startsWith('//') || link.startsWith('#')) {
                  return link;
                }
                return regionalizePath(link, currentBranchCode);
              };

              return (
                <CarouselItem key={`sales-${item.slug || index}`} className="pl-0 basis-full">
                  {item.link ? (
                    <a href={getRegionalizedLink(item.link)} className="block w-full">
                      {content}
                    </a>
                  ) : (
                    content
                  )}
                </CarouselItem>
              );
            })}
          </CarouselContent>
          <CarouselPrevious className="left-2 md:left-4 bg-white/20 hover:bg-white/30 text-white border-white/30 h-6 w-6" />
          <CarouselNext className="right-2 md:right-4 bg-white/20 hover:bg-white/30 text-white border-white/30 h-6 w-6" />
        </Carousel>
      </div>
    </div>
  );
}

